import i18n from "i18next";

import { PagesStyled } from "src/app/pages/pagesStyled";
import { PageLayout } from "../../../components/AppLayout/components/Content/components";
import { PrimaryButton } from "../../../components/Buttons/components/ActionButton";
import { useLogoutMutation } from "../../../core/router/auth/serverApi";
import { routes } from "../../../core/router/config/routes";

export const NotFoundPage = () => {
    const [logout] = useLogoutMutation();
    const handleBackToLogin = async () => {
        await logout({});
        window.location.href = routes.login.path;
    };
    return (
        <PageLayout>
            <PagesStyled>
                <p className="aevi-section-subtitle">{i18n.t("common.notFound")}</p>
                <PrimaryButton onClick={handleBackToLogin} data-name="login_button">
                    {i18n.t("common.backToLogin")}
                </PrimaryButton>
            </PagesStyled>
        </PageLayout>
    );
};
